import {  LostCargoReturnDetailPageProvider } from '../context/LostCargoReturnDetailPageContext';
import LostCargoReturnDetailPageContent from './LostCargoReturnDetailPageContent';

function LostCargoReturnDetailPageLayout() {
  return (
    <LostCargoReturnDetailPageProvider>
      <LostCargoReturnDetailPageContent />
    </LostCargoReturnDetailPageProvider>
  )
}

export default LostCargoReturnDetailPageLayout